//LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";

const AboutUsMain: React.FC = () => {

    const { t } = useTranslation();

    const services = [
        t('aboutUsPage.service1'),
        t('aboutUsPage.service2'),
        t('aboutUsPage.service3'),
        t('aboutUsPage.service4'),
        t('aboutUsPage.service5'),
    ]

    return(
        <>
            <section className="bg-white mb-5">
                <h2>{t('aboutUsPage.title1')}</h2>
                <p className="mb-4 sub-title">{t('aboutUsPage.subTitle1')}</p>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para1') as string }} />
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para2') as string }} />
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para3') as string }} />
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para4') as string }} />
            </section>
            <section className="bg-white">
                <h2>{t('aboutUsPage.title2')}</h2>
                <p className="mb-4 sub-title">{t('aboutUsPage.subTitle2')}</p>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para5') as string }} />
                <div className="row justify-content-center align-items-center">
                    <div className="col-12 col-lg-7">
                        <ul className="text-center text-white pl-0">
                            {services.map((service, index) => (
                                <li key={index} className="col-12 col-md-10 col-lg-12  bg-primary mb-3 mx-auto p-4">
                                    {service}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="col-12 col-sm-10 col-lg-5 col-xl-4">
                        <img src="/assets/images/altrePag/chiavi.jpg" className="img-fluid" alt={`${t('aboutUsPage.imgAlt')}`} />
                    </div>
                </div>
            </section>
        </>
    )
};
export default AboutUsMain;